
import {
  QUOTATIONS_PAGINATOR_SET_CONFIGURATION_SLOPES_EMIT_QUOTATIONS,

  QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_REQUEST,
  QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_SUCCESS,
  QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_ERROR,
} from 'Redux/types/tableQuotationsTypes';

import { BACKEND_URL_QUOTATION } from 'Config/routes';
import { CALL_ACTIONS } from 'Redux/middleware';
import { filtersToDto } from 'Api/actions/quotation/dto/filtersDto';

// ------------------------------- ------------------------------- ------------------------------- -------------------------------
// Para poner el número de página y el Page size
const configurationQuotationsSlopesToEmit = ({ page, page_size: pageSize }) => ({
  type: QUOTATIONS_PAGINATOR_SET_CONFIGURATION_SLOPES_EMIT_QUOTATIONS,

  page,
  page_size: pageSize,
});

export const setConfigurationQuotationsSlopesToEmit = (data) => (dispatch) => dispatch(configurationQuotationsSlopesToEmit(data));


// ------------------------------- ------------------------------- ------------------------------- -------------------------------
// quotations SLOPES | Done
const getQuotationsSlopesToEmitAction = (params) => ({
  [CALL_ACTIONS]: {
    TYPES: [
      QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_REQUEST,
      QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_SUCCESS,
      QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_ERROR,
    ],
    ENDPOINT: BACKEND_URL_QUOTATION,
    METHOD: 'GET',
    PARAMS: params,
  },
});

export const getQuotationsSlopesToEmit = ({ state }) => (dispatch, getState) => {
  const stateGeted = getState();
  const { page_size: pageSize, page } = stateGeted.tableQuotations.quotationsSlopesToEmit;
  const filterQuotations = stateGeted.tableQuotations.filtersTableQuotations;

  return (dispatch(getQuotationsSlopesToEmitAction({
    ...filtersToDto(filterQuotations),
    // vendedores: (filterQuotations.vendedores || []).join(','),
    // aseguradoras: (filterQuotations.aseguradoras || []).join(','),

    state,
    page_size: pageSize,
    page,
  })));
};
